import angular from 'angular'
import overlay from './overlay.directive'

export default angular
  .module('ellipsis.overlay', [])
  .directive('overlay', overlay)
